resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function Collection() {
    this.extends = [_Input];
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    // Before contained components so that the empty template item is clean and new items can be parsed from scratch
    this.priority = 900;

    this.fieldsetNode = null;
    this.placeholderNode = null;
    this.containerDiv = null;
    this.placeholder = "";
    this.type = "";
    this.allowGroupErrorMessage = false;
    this.disableLastRemove = false;
    this.indexOffset = 0;
    this.maxItems = 3;
    this.groupElements = [];

    this._itemNodes = [];
    this._addItemButton = null;
    this._collectionElementsSelector = 'input, select';
    this._itemTemplate = null;

    this._initialized = false;

    //Callbacks
    this.onAdd = [];
    this.onRemove = [];
    this.onRemoveLast = [];

    this.init = function() {
        this._$node = $(this.node);
        this.name = this.name || this._$node.attr("name");

        // Add class
        this._$node.addClass('mogo-ui-collection');
        this.containerDiv = this.node;

        // Wrap in fieldset
        this.fieldsetNode = $('<fieldset></fieldset>').insertBefore(this.node);
        var childNodes = this.node.childNodes;
        for (var i = childNodes.length - 1; i >= 0; i--) {
            $(childNodes[i]).detach().prependTo(this.fieldsetNode);
        }
        $(this.fieldsetNode).appendTo(this.node);

        // wrap child nodes in a fieldset as the first item
        this._itemNodes[0] = $('<fieldset></fieldset>').insertBefore(this.node);
        childNodes = $(this.fieldsetNode).children();
        childNodes.detach().prependTo(this._itemNodes[0]);
        this._itemNodes[0].appendTo(this.fieldsetNode);

        // Add remove button (but hide it for the first item)
        var removeButton = $('<a class="collection-remove-item" href="#">' + this.removeButtonText + '</a>').prependTo(this._itemNodes[0]);
        removeButton.on('click', this._onRemoveItemClick.bind(this));

        // Add title for item
        if (this.itemTitle)
            $('<legend>' + this.itemTitle + '</legend>').prependTo(this._itemNodes[0]);

        // Store name attributes so that validation doesn't pick them up
        this._itemNodes[0].find(this._collectionElementsSelector).each(function(index, item) {
            item.dataset.name = item.name;
            item.name = '';
        });

        // Clone this fieldset as an item template
        this._itemTemplate = this._itemNodes[0].clone(true);

        // Remove ids from item template's form fields (ids will be generated instead of user-assigned)
        this._itemTemplate.find(this._collectionElementsSelector).each(function(index, item) {
            item.id = '';
        });

        // Add an "add item" button to the bottom of the collection
        this._addItemButton = $('<button type="button" class="btn secondary hollow"><span class="label">' + this.addButtonText + '</span></button>');
        this._addItemButton.addClass(this.addButtonClass);
        this._addItemButton.appendTo(this.fieldsetNode);
        this._addItemButton.on('click', this.addItem.bind(this));

        this._updateAddButton();
        if (this.disableLastRemove) this._updateRemoveButton();

        // Check for legend/placeholder
        if (this._$node.children('legend').length > 0) {
            this.placeholderNode = this._$node.children("legend").eq(0);
        } else if (this.placeholder != "") {
            this.placeholderNode = $('<legend>' + this.placeholder + '</legend>');
            this.placeholderNode.prependTo($(this.fieldsetNode));
        }

        this._removeItem(this._itemNodes[0]);

        this._super();

        this._$node.css('display', 'block');
    };

    this.initAllReady = function() {
        this._addElementsToCollection(this._$node.find(this._collectionElementsSelector));
    };

    this._addElementsToCollection = function(elements) {
        Array.prototype.push.apply(this.groupElements, elements);
        for (var i = 0; i < elements.length; i++) {
            $($(elements)[i]).mogo().groupInstance = this;
        }
    };

    this._removeElementsFromCollection = function(elements) {
        this.groupElements = this.groupElements.filter(function(item) {
            return elements.toArray().indexOf(item) === -1;
        });
        for (var i = 0; i < elements.length; i++) {
            $($(elements)[i]).mogo().groupInstance = null;
        }
    };

    this._updateVal = function($node, val) {
        var itemElements = $node.find(this._collectionElementsSelector);
        for (var k = 0; k < itemElements.length; k++) {
            var element = itemElements[k];
            var name = element.dataset.name;
            if (val[name]) {
                var $element = $(element);
                if (!$element.mogo().create) $element = $element.mogo();
                $element.val(val[name]);
            }
        }

        //was deleted make sure this item is hidden
        if (val._delete) this._removeItem($node);
    };

    this.val = function(value) {

        // value provided: populate collection with this value
        if (value) {
            if (Array.isArray(value)) {
                var newValue = value;
                // use only values where the type matches this collection's type
                if (this.type) newValue = value.filter(function(val) { return val.type == this.type; }.bind(this));
                var currentVal = this.val();
                if (JSON.stringify(newValue) !== JSON.stringify(currentVal)) {
                    for (var i = this._itemNodes.length - 1; i >= 0; i--) {
                        $(this._itemNodes[i]).data("_delete", true); //force items to be removed
                        this._removeItem(this._itemNodes[i]);
                    }

                    for (var i = 0; i < newValue.length; i++) {
                        this._updateVal(this._addItem(),newValue[i]);
                    }
                }
            }
        }

        // no value provided: retrieve current value of collection
        else {
            var resultArr = [];
            for (var i = 0; i < this._itemNodes.length; i++) {
                var item = this._itemNodes[i];
                var itemValueObj = {};

                var itemElements = item.find(this._collectionElementsSelector);
                for (var j = 0; j < itemElements.length; j++) {
                    var element = itemElements[j];
                    var $element = $(element);
                    if (!$element.mogo().create) $element = $element.mogo();

                    // use each element's val() method to get their individual values
                    var elementValue = $element.val();

                    // use element's name as key for it's value
                    if (elementValue !== "") itemValueObj[element.dataset.name] = parseInt(elementValue);
                }

                if (this.type) itemValueObj.type = this.type; // add type property if it exists on the collection
                if ($(item).data("_delete")) itemValueObj._delete = true; // add deleted flag if this item has been deleted

                resultArr.push(itemValueObj);
            }
            return resultArr;
        }
    };

    this._addItem = function() {
        // clone the item template
        var newItem = this._itemTemplate.clone(true);

        // add to the end of collection list
        newItem.insertBefore(this._addItemButton);
        newItem.mogo().parse();

        // add to list of items
        this._itemNodes.push(newItem);

        this._updateNames();
        // add elements in item to list of collection elements
        this._addElementsToCollection(newItem.find(this._collectionElementsSelector));

        // disable "add item" button if needed
        this._updateAddButton();
        if (this.disableLastRemove) this._updateRemoveButton();

        return newItem;
    };

    this.addItem = function() {
        var newItem = this._addItem();


        for (var i = 0; i < this.onAdd.length; i++) this.onAdd[i](newItem);
        this._$node.trigger("change");
        return newItem;
    };

    this._onRemoveItemClick = function(evt) {
        var removeLink = $(evt.target);
        if (!removeLink.hasClass('collection-remove-item--disabled')) {
            this.removeItem($(evt.target).parent());
        }
        return false;
    };

    this.clear = function() {
        var visible = this._getVisible();
        for (var i = visible.length - 1; i >= 0; i--) {
            this._removeItem(visible[i],true);
        }
        if (visible.length !== 0) { //items
            this._$node.trigger("change");
        }
    };

    this._removeItem = function(itemToRemove, triggerChange) {
        // remove elements in item from list of collection elements
        this._removeElementsFromCollection(itemToRemove.find(this._collectionElementsSelector));

        var hidden = itemToRemove.find("[name$=id]").val() && !itemToRemove.data('_delete');
        if (hidden) { //if has id and not already deleted

            // flag item as deleted
            itemToRemove.data('_delete', true);

            // hide item
            itemToRemove.hide();
        } else {
            var itemToRemoveIndex = itemToRemove.prevAll('fieldset').length;
            // remove item from list of items
            this._itemNodes.splice(itemToRemoveIndex, 1);


            // remove item from document
            itemToRemove.mogo().destroy();
        }
        this._updateNames();

        // enable "add item" button if needed
        this._updateAddButton();
        if (this.disableLastRemove) this._updateRemoveButton();

        var result = hidden? itemToRemove:null;

        if (triggerChange) {
            for (var i = 0; i < this.onRemove.length; i++) this.onRemove[i](result);
            if (this._getVisible().length === 0) for (var j = 0; j < this.onRemoveLast.length; j++) this.onRemoveLast[j]();
        }

        return result;
    };

    this.removeItem = function(itemToRemove) {
        var result = this._removeItem(itemToRemove, true);
        this._$node.trigger("change");
        return result;
    };

    this._updateNames = function() {
      // Store name attributes so that validation doesn't pick them up
      for (var i = 0; i < this._itemNodes.length; i++) {
        this._itemNodes[i].find(this._collectionElementsSelector).each(function(index, item) {
          var actualIndex = this.indexOffset + i;
          item.name = this.name + '[' + actualIndex + '].' + item.dataset.name;
        }.bind(this));
      }
    };

    this._getVisible = function() {
        return $(this._itemNodes).filter(function(index) {
            return !this.data('_delete');
        });
    };

    this._updateRemoveButton = function() {
        // if there is only one item left, hide that item's Remove button
        var visibleItemNodes = this._getVisible();
        if (visibleItemNodes.length > 0) {
            var $firstRemoveButton = visibleItemNodes[0].find('.collection-remove-item');
            if (visibleItemNodes.length === 1) {
                $firstRemoveButton[0].disabled = true;
                $firstRemoveButton.addClass('collection-remove-item--disabled');
            } else { // show the first item's Remove button
                $firstRemoveButton[0].disabled = false;
                $firstRemoveButton.removeClass('collection-remove-item--disabled');
            }
        }
    };

    this._updateAddButton = function() {
        var visibleItemNodes = this._getVisible();
        if (visibleItemNodes.length >= this.maxItems) {
            this._addItemButton[0].disabled = true;
            this._addItemButton.addClass('disabled');
        } else {
            this._addItemButton[0].disabled = false;
            this._addItemButton.removeClass('disabled');
        }
    };

    this.destroy = function() { };
}
